var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgTemplateBg = function SvgTemplateBg(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 856,
    height: 120,
    viewBox: "0 0 856 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_416_18813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 856,
    height: 120
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 855,
    height: 119,
    rx: 5.5,
    fill: "#F8F9FA",
    stroke: "#E9ECEF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_416_18813)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_416_18813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M586.98 70.7429L537.007 124.221C532.827 128.694 535.999 136 542.122 136H868C871.866 136 875 132.866 875 129V-14C875 -17.866 871.866 -21 868 -21H810.943C809.004 -21 807.152 -20.1959 805.829 -18.7793L732.403 59.7964C729.636 62.7573 724.941 62.7573 722.174 59.7964L691.845 27.3401C689.078 24.3792 684.383 24.3792 681.616 27.3401L624.248 88.7315C621.481 91.6925 616.786 91.6925 614.019 88.7315L597.209 70.7429C594.442 67.7819 589.747 67.7819 586.98 70.7429Z",
    fill: "url(#paint0_linear_416_18813)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M586.98 70.7429L537.007 124.221C532.827 128.694 535.999 136 542.122 136H868C871.866 136 875 132.866 875 129V-14C875 -17.866 871.866 -21 868 -21H810.943C809.004 -21 807.152 -20.1959 805.829 -18.7793L732.403 59.7964C729.636 62.7573 724.941 62.7573 722.174 59.7964L691.845 27.3401C689.078 24.3792 684.383 24.3792 681.616 27.3401L624.248 88.7315C621.481 91.6925 616.786 91.6925 614.019 88.7315L597.209 70.7429C594.442 67.7819 589.747 67.7819 586.98 70.7429Z",
    stroke: "url(#paint1_linear_416_18813)",
    strokeWidth: 3,
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_416_18813)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: -16,
    r: 48,
    fill: "#228BE6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_416_18813",
    x: 519.605,
    y: -22.5,
    width: 356.895,
    height: 168,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -10,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.905882 0 0 0 0 0.960784 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_18813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_18813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_416_18813",
    x: -54,
    y: -72,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.2 0 0 0 0 0.603922 0 0 0 0 0.941176 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_416_18813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_416_18813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_416_18813",
    x1: 862.5,
    y1: -29,
    x2: 539,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7F5FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_416_18813",
    x1: 840.5,
    y1: -26,
    x2: 537.5,
    y2: 124.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#339AF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333BF0",
    stopOpacity: 0
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgTemplateBg);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/template_bg.e2d447cf3ab23f11e25bbbb2f07f74ed.svg";